module.exports = __webpack_public_path__ + "static/media/budgety-gif.2dd47b30.gif";